<template>
  <div class="level is-mobile">
    <a class="level-left" @click="updateValue()" :class="currentClass">
      <p class="level-item">
        <span class="icon" :class="disabled ? 'has-text-grey-light' :'has-text-link'">
          <i class="mdi mdi-24px" :class="value ? `mdi-${trueIcon}` : `mdi-${falseIcon}`"></i>
        </span>
      </p>
      <div v-if="slotPassed()" class="level-item" :class="currentClass">
        <slot></slot>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    trueIcon: {
      type: String,
      default: "checkbox-marked"
    },
    falseIcon: {
      type: String,
      default: "checkbox-blank-outline"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue() {
      if (this.disabled) {
        return;
      }
      this.$emit("input", !this.value);      
    },
    slotPassed(){
      return this.$slots.default != null && this.$slots.default.length > 0
    }
  },
  computed: {
    currentClass() {
      return this.disabled ? "disabled" : "has-cursor";
    },
    
  }
};
</script>

<style scoped>
.has-cursor {
  cursor: pointer;
  color: #4a4a4a;
}
.disabled {
  cursor: not-allowed;
  color: #7a7a7a;
}
</style>


